import AdvertiserApi from '@/api/AdvertiserApi'
import immer from 'immer'

export default class AdvertiserRepository {
  static async changeStatus(id, status) {
    try {
      const ret = await AdvertiserApi.fetchAdvertiser(id)
      const advertiser = ret.item
      const advertiserNew = immer(advertiser, draft => {
        draft.status = status
      })
      return await AdvertiserApi.editAdvertiser(id, advertiserNew)
    } catch (e) {
      throw new Error('ステータスの変更に失敗しました')
    }
  }
}
